import { $config } from "../conf";
import { api, staticApi } from "../services";
import { staticReqMapping } from "../services/staticReqMapping";
import md5 from "md5";

const state = { apis: {} };
const getters = {
  getApi: (state) => (params) => {
    let staticUrl = staticReqMapping.getStaticUrl(params.apiPath, params),
      key = md5(JSON.stringify(params));
    return (
      state.apis[params.apiPath] && state.apis[params.apiPath][staticUrl || key]
    );
  },
};
const actions = {
  onSync({ state, getters, commit }, params) {
    let staticUrl = staticReqMapping.getStaticUrl(params.apiPath, params),
      key = md5(JSON.stringify(params));

    if ($config.isStatic && getters.getApi(params) && !params.isRefresh) {
      return getters.getApi(params);
    }

    let staticPromise;
    if ($config.isStatic && params.isStatic && staticUrl) {
      staticPromise = staticApi.request(staticUrl);
    } else {
      staticPromise = Promise.reject({
        errorType: "static_wrong",
        errorMsg:
          $config.isStatic && params.isStatic ? "此JSON不存在" : "未开启静态化",
      });
    }

    let value = staticPromise.catch((data) => {
      let apiPromise;
      if ($config.isSK) {
        apiPromise = api.request(params.apiPath, params);
      } else {
        apiPromise = Promise.reject(data);
      }
      return apiPromise;
    });

    commit("setApis", {
      apiPath: params.apiPath,
      key: staticUrl || key,
      value: value,
    });
    return value;
  },
};
const mutations = {
  setApis(state, { apiPath, key, value }) {
    state.apis = {
      ...state.apis,
      [apiPath]: {
        ...state.apis[apiPath],
        [key]: value,
      },
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
